import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import FacebookButton from '../../containers/facebook-button.container';
import Footer from '../../containers/footer.container';
import Title from '../title';
import TopNavBar from '../../containers/top-nav-bar.container';
import AlertsContainer from '../../containers/account/alerts.container';
import { formatMessage } from '../../lib/intl';

import FormField from '../form-field';
import '../../css/account.css';

const i18n = defineMessages({
  emailFieldLabel: {
    id: 'accountForm.fields.email.label',
    defaultMessage: 'E-mail',
  },
  emailFieldPlaceholder: {
    id: 'accountForm.fields.email.placeholder',
    defaultMessage: 'Email',
  },
  emailNotPresent: {
    id: 'accountForm.errors.emailNotPresent',
    defaultMessage: 'email must be present',
  },
  fullNameFieldLabel: {
    id: 'accountForm.fields.fullName.label',
    defaultMessage: 'Full name',
  },
  fullNameFieldPlaceholder: {
    id: 'accountForm.fields.fullNAme.placeholder',
    defaultMessage: 'Name',
  },
  fullNameNotPresent: {
    id: 'accountForm.errors.fullNameNotPresent',
    defaultMessage: 'full name must be present',
  },
  yourInformationSubtitle: {
    id: 'accountForm.yourInformation.subtitle',
    defaultMessage: 'Your information',
  },
});

class Account extends Component {
  constructor(props) {
    super(props);

    this.formatMessage = formatMessage(this.props.intl);
    this.onResetPasswordClick = this.onResetPasswordClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(data) {
    this.props.onSubmit(data);
  }

  onResetPasswordClick() {
    this.props.onResetPasswordClick(this.props.user.email);
  }

  renderContent() {
    return (
      <div className="clearfix content">
        <Title
          text={this.formatMessage(i18n.yourInformationSubtitle)}
          className="black mb-4"
          bigger
        />
        <div className="account-form float-left">
          {this.renderForm()}
        </div>
        <div className="profile-pic float-left ml-5">
          {this.renderProfilePic()}
        </div>
      </div>
    );
  }

  renderFacebookButton() {
    if (this.props.facebookAuthenticated) return null;

    return (
      <FacebookButton>
        <FormattedMessage
          id="accountForm.loginWithFacebook"
          defaultMessage="Connect with Facebook"
        />
      </FacebookButton>
    );
  }

  renderForm() {
    const { handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit(this.onSubmit)}>
        <Field
          component={FormField}
          name="fullName"
          label={this.formatMessage(i18n.fullNameFieldLabel)}
          placeholder={this.formatMessage(i18n.fullNameFieldPlaceholder)}
          type="text"
        />
        <Field
          component={FormField}
          name="email"
          label={this.formatMessage(i18n.emailFieldLabel)}
          placeholder={this.formatMessage(i18n.emailFieldPlaceholder)}
          type="email"
        />
        {this.renderFacebookButton()}
        {this.renderResetPasswordLink()}
        <button
          className="btn btn-primary mt-5"
          disabled={this.props.submitting}
          type="submit"
        >
          <FormattedMessage
            id="accountForm.submit"
            defaultMessage="Save changes"
          />
        </button>
      </form>
    );
  }

  renderProfilePic() {
    const { user } = this.props;
    if (!user.profileImage) return null;
    return (
      <div>
        <img src={user.profileImage} alt={user.fullName} />
        <button className="btn btn-secondary mt-2" type="button">
          <FormattedMessage
            id="accountForm.fields.uploadPicture.button"
            defaultMessage="Upload picture"
          />
        </button>
      </div>
    );
  }

  renderResetPasswordLink() {
    return (
      <div className="my-4">
        <label>
          <FormattedMessage
            id="accountForm.fields.passwordReset.label"
            defaultMessage="Change password"
          />
        </label>
        <br />
        <a onClick={this.onResetPasswordClick} href="#recover-password">
          <FormattedMessage
            id="accountForm.fields.passwordReset.link"
            defaultMessage="Click to receive your password-reset email"
          />
        </a>
      </div>
    );
  }

  render() {
    return (
      <div>
        <TopNavBar user={this.props.user} />
        <div className="container px-0">
          <AlertsContainer />
          <h1 className="my-5">
            <FormattedMessage
              id="accountForm.pageTitle"
              defaultMessage="My account"
            />
          </h1>
          <div className="my-account rounded">
            {this.renderContent()}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

Account.defaultProps = {
  onSubmit: () => { },
  onResetPasswordClick: () => { },
  facebookAuthenticated: false,
};

const validate = (values, props) => {
  const { intl: { formatMessage } } = props;
  const errors = {};
  if (!values.email) {
    errors.email = formatMessage(i18n.emailNotPresent);
  }

  if (!values.fullName) {
    errors.fullName = formatMessage(i18n.fullNameNotPresent);
  }

  return errors;
};

export default injectIntl(reduxForm({ form: 'editAccount', validate })(Account));



// WEBPACK FOOTER //
// ./src/desktop/components/account/form.js